import csrf from "./csrf";
import EventBus from "../eventBus";
import siteLanguage from "../config/siteLanguage";
import { useDirtyStore } from "../stores/dirty";

export default {
    mixins: [csrf],
    props: {
        lockable: {
            type: Boolean,
            required: false,
            default: false,
        },
        versioned: {
            type: Boolean,
            required: false,
            default: false,
        },
        user: {
            type: Object,
            required: false,
        },
        propHasLock: {
            type: Boolean,
            required: false,
            default: true,
        },
        propDocumentLock: {
            type: Object,
            required: false,
        },
        className: {
            type: String,
            required: false,
        },

        editable: {
            type: Boolean,
            required: false,
            default: true,
        },
        publishable: {
            type: Boolean,
            required: false,
            default: true,
        },
        submitViaAjax: {
            type: Boolean,
            required: true,
        },
        pageDocument: {
            type: Boolean,
            default: false,
            required: false,
        },
        siteHasPreview: {
            type: Boolean,
            required: false,
            default: false,
        },
        errorBag: {
            type: [Object, Array],
            required: false,
        },
        oldData: {
            type: [Object, Array],
            required: false,
        },
        formRoute: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            required: false,
        },
        redirectRoute: {
            type: String,
            required: false,
        },
        baseDocument: {
            default: null,
            required: false,
        },
        documentType: {
            default: null,
            required: false,
        },
        languageData: {
            default: () => {
                return {
                    id: siteLanguage.language.ENGLISH,
                    iso: siteLanguage.iso.ENGLISH,
                    slug: "en",
                };
            },
            required: false,
        },
        followRedirects: {
            type: Boolean,
            default: true,
        },
        preFilled: {
            type: Object,
            required: false,
        },
        deleteRoute: {
            type: String,
            required: false,
            default: "",
        },
        deleteValue: {
            type: String,
            required: false,
            default: "",
        },
        canDelete: {
            type: Boolean,
            required: false,
            default: true,
        },
        canCreate: {
            type: Boolean,
            required: false,
            default: true,
        },
        createRoute: {
            type: String,
            required: false,
            default: "",
        },
        createValue: {
            type: String,
            required: false,
            default: "",
        },
        indexRoute: {
            type: String,
            required: false,
            default: "",
        },
        indexValue: {
            type: String,
            required: false,
            default: "",
        },
        title: {
            type: String,
            required: false,
            default: "",
        },
        subtitle: {
            type: String,
            required: false,
            default: "",
        },
        isSlideOver: {
            type: Boolean,
            required: false,
            default: false,
        },
        status: {
            type: Object,
            required: false,
        },
        dataCleaningEnabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        initVersionId: {
            type: Number,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            initialForm: null,

            hasLock: this.propHasLock,
            documentLock: this.propDocumentLock,

            versionId: this.initVersionId,
            lastUpdatedBy: null,

            errors: this.errorBag || {},
            submitButtonDisabled: false,
            contentSectionWithHowTo: null,
            contentSectionWithBonusListTop: null,
            contentSectionWithBonusListBottom: null,
            contentSectionsWithRanking: [],
            form: {
                baseDocument:
                    typeof this.baseDocument === "string" && this.baseDocument
                        ? JSON.parse(this.baseDocument)
                        : this.baseDocument,
                language: this.getFormData("language", this.languageData),
                gallery: this.getFormData("gallery", []),
            },
            dirtyStore: useDirtyStore(),
        };
    },
    mounted: function () {
        if (this.pageDocument) {
            this.generateUri();
        }
        if (this.preFilled) {
            Object.keys(this.preFilled).forEach((key) => {
                if (this.form[key] !== undefined) {
                    this.form[key] = this.preFilled[key];
                }
            });
        }
        EventBus.$on("add-to-gallery", this.addToGallery);
        EventBus.$on("remove-from-gallery", this.removeFromGallery);

        if (this.status) {
            this.form.status = this.status;
        }

        window.addEventListener("beforeunload", (e) => {
            if (this.lockable && this.hasLock && !!this.documentLock) {
                this.releaseLock();
            }

            if (this.submitButtonDisabled || !this.dirtyStore.isDirty) {
                return undefined;
            }
            e.returnValue = true;

            // if user clicks cancel, take lock again
            if (this.lockable) {
                setTimeout(() => {
                    setTimeout(() => {
                        this.takeOver();
                    }, 3000);
                }, 100);
            }

            return true;
        });

        // setInterval(() => {
        //     axios
        //         .post(route("api.document-locks.update", [this.className, this.data.id]))
        //         .then((response) => {
        //             this.documentLock = response.data.documentLock;
        //             this.hasLock = response.data.hasLock;
        //         })
        //         .catch((error) => {
        //             console.log(error);
        //             const errorMessage = this.constructErrorMessage(error);
        //             this.$notify({
        //                 group: "formError",
        //                 title: "Error Refreshing Lock",
        //                 text: errorMessage,
        //             });
        //         });
        //
        // }, 5000);

        if (this.lockable) {
            Echo.private(`document-locks.${this.className}.${this.data.id}`)
                .listen("DocumentLockAssigned", (e) => {
                    this.documentLock = e.documentLock;
                    this.hasLock = e.documentLock.user_id === this.user.id;
                })
                .listen("DocumentLockReleased", (e) => {
                    this.documentLock = null;
                    this.hasLock = false;
                });
        }

        if (this.versioned) {
            Echo.private(
                `document-updates.${this.className}.${this.data.id}`
            ).listen("DocumentUpdated", (e) => {
                this.versionId = e.version_id;
                this.lastUpdatedBy = e.updated_by;
            });
        }

        if (this.initialForm == null) {
            this.$nextTick(() => {
                // need timeout to wait for bonuslist to load
                setTimeout(() => {
                    this.initialForm = this.form;
                }, 2000);
            });
        }
    },
    methods: {
        howToAdded(uid) {
            this.contentSectionWithHowTo = uid;
        },
        howToDeleted(uid) {
            if (this.contentSectionWithHowTo === uid) {
                this.contentSectionWithHowTo = null;
            }
        },
        bonusListTopAdded(uid) {
            this.contentSectionWithBonusListTop = uid;
        },
        bonusListTopDeleted(uid) {
            if (this.contentSectionWithBonusListTop === uid) {
                this.contentSectionWithBonusListTop = null;
            }
        },
        bonusListBottomAdded(uid) {
            this.contentSectionWithBonusListBottom = uid;
        },
        bonusListBottomDeleted(uid) {
            if (this.contentSectionWithBonusListBottom === uid) {
                this.contentSectionWithBonusListBottom = null;
            }
        },
        rankingAdded(uid) {
            if (this.contentSectionsWithRanking.indexOf(uid) < 0) {
                this.contentSectionsWithRanking.push(uid);
            }
        },
        rankingDeleted(uid) {
            let index = this.contentSectionsWithRanking.indexOf(uid);
            if (index >= 0) {
                this.contentSectionsWithRanking.splice(index, 1);
            }
        },
        attemptTakeover() {
            this.$confirm({
                message: `Are you sure you want to take over?`,
                button: {
                    no: "No",
                    yes: "Yes",
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.takeOver();
                    }
                },
            });
        },
        takeOver() {
            axios
                .post(
                    route("api.document-locks.store", [
                        this.className,
                        this.data.id,
                    ])
                )
                .then((response) => {
                    this.documentLock = response.data.documentLock;
                    this.hasLock = response.data.hasLock;
                })
                .catch((error) => {
                    console.log(error);
                    const errorMessage = this.constructErrorMessage(error);
                    this.$notify({
                        group: "formError",
                        title: "Error Taking Over Lock",
                        text: errorMessage,
                    });
                });
        },
        releaseLock() {
            axios
                .delete(
                    route("api.document-locks.delete", [
                        this.className,
                        this.data.id,
                    ])
                )
                .then((response) => {
                    this.documentLock = null;
                    this.hasLock = response.data.hasLock;
                })
                .catch((error) => {
                    console.log(error);
                    const errorMessage = this.constructErrorMessage(error);
                    this.$notify({
                        group: "formError",
                        title: "Error Releasing Lock",
                        text: errorMessage,
                    });
                });
        },
        getFormData(key, fallback = null) {
            return this.oldData?.[key] ?? this.data?.[key] ?? fallback;
        },
        getReferenceData(key) {
            if (this.oldData?.[key]) {
                return this.oldData[key];
            }
            return this.data?.[key] ?? null;
        },
        constructErrorMessage(error = null) {
            return `
            Please take a screenshot and inform someone who can let a developer know about this error.<br><br>
            File: ${error?.response?.data?.file ?? "Unknown"}<br><br>
            Line: ${error?.response?.data?.line ?? "Unknown"}<br><br>
            Message: ${error?.response?.data?.message ?? "Unknown"}
        `;
        },
        cleanData(data) {
            // function added to solve 413 errors

            if (!this.dataCleaningEnabled) return data;

            const excludedKeys = [
                "max_deposits",
                "min_deposits",
                "withdrawal_limits",
            ];

            const clean = {};
            for (const key in data) {
                if (!data.hasOwnProperty(key)) continue;

                if (excludedKeys.includes(key)) {
                    clean[key] = data[key];
                    continue;
                }

                if (
                    typeof data[key] === "object" &&
                    !Array.isArray(data[key]) &&
                    data.hasOwnProperty(`${key}_id`)
                ) {
                    // this is the object for a reference, we skip it, we just need the id
                    continue;
                }

                if (
                    typeof data[key] === "object" &&
                    Array.isArray(data[key]) &&
                    data[key].length
                ) {
                    // this could be a multireference array
                    if (
                        typeof data[key][0] === "object" &&
                        !Array.isArray(data[key][0]) &&
                        data[key][0].hasOwnProperty("id")
                    ) {
                        clean[key] = data[key].map((item) => {
                            return { id: item.id };
                        });
                        continue;
                    }
                }

                clean[key] = data[key];
            }

            return clean;
        },
        submit() {
            this.submitButtonDisabled = true;
            if (this.submitViaAjax) {
                const postOrPatch = this.data ? "patch" : "post";
                axios[postOrPatch](this.formRoute, this.cleanData(this.form))
                    .then((response) => {
                        let object = null;
                        if ("data" in response.data) {
                            object = response.data.data;
                        } else {
                            object = response.data;
                        }
                        this.$emit("created", object);
                        if (
                            response.data.redirectRoute &&
                            this.followRedirects
                        ) {
                            this.redirectRaw(response.data.redirectRoute);
                        } else if (this.redirectRoute) {
                            this.redirectRaw(this.redirectRoute);
                        }
                    })
                    .catch((err) => {
                        this.submitButtonDisabled = false;
                        if (err.response.status == 422) {
                            this.errors = err.response.data.errors;
                        } else {
                            const errorMessage = this.constructErrorMessage(
                                err
                            );
                            this.$notify({
                                group: "formError",
                                title: "Error Saving Form",
                                text: errorMessage,
                            });
                        }
                    });
            } else {
                this.$refs.form.submit();
                return;
            }
        },
        addToGallery(file) {
            this.form.gallery = this.form.gallery.filter(function (el) {
                return el != null;
            });
            if (!this.form.gallery) return;

            const fileIsInGallery = this.form.gallery
                .map((media) => media.id || null)
                .includes(file.id);

            if (!fileIsInGallery) {
                this.form.gallery.push(file);
            }
        },
        removeFromGallery(file) {
            this.form.gallery = this.form.gallery.filter(function (el) {
                return el != null;
            });
            if (!this.form.gallery) return;

            const fileIsInGallery = this.form.gallery
                .map((media) => media.id || null)
                .includes(file.id);

            if (fileIsInGallery) {
                const index = this.form.gallery
                    .map((file) => file.id)
                    .indexOf(file.id);
                this.form.gallery.splice(index, 1);
            }
        },
        generateUri: function () {
            const slugs = this.addParentUri(this.form);
            this.form.uri = slugs.join("/")
                ? `/${slugs.join("/")}/`
                      // we take care of double slashes here, for cases where a homepage is part of the parent chain
                      .replace(/\/+/g, "/")
                : "";
        },
        setBreadcrumb: function () {
            this.form.breadcrumb = this.form.slug.replace(/-+/gi, " ");
        },
        addParentUri: function (document) {
            let uri = ["/"];

            if (document.parent) {
                uri = [document.parent.uri];
            }

            uri.push(document.slug);

            return uri;
        },
        shouldShowPreviewButton: function () {
            if (!this.data) {
                return false;
            }
            if (!this.data.status_id == 2) {
                return false;
            }
            return this.siteHasPreview;
        },
        submitPreviewSite: function (iso, uri) {
            axios
                .post(route("preview", iso), { uri: uri })
                .then((response) => {
                    if (
                        response.data.redirect_url &&
                        response.data.redirect_url.includes(uri)
                    ) {
                        this.redirectRaw(response.data.redirect_url, true);
                    } else {
                        const errorMessage = this.constructErrorMessage();
                        this.$notify({
                            group: "formError",
                            title: "Error Previewing Site",
                            text: errorMessage,
                        });
                    }
                })
                .catch((error) => {
                    const errorMessage = this.constructErrorMessage(error);
                    this.$notify({
                        group: "formError",
                        title: "Error Previewing Site",
                        text: errorMessage,
                    });
                });
        },
    },
    watch: {
        "form.parent": function (newValue) {
            if (this.pageDocument) {
                this.generateUri();
                this.form.parent_type = newValue ? newValue.model_name : null;
                this.form.parent_id = newValue ? newValue.id : null;
            }
        },
        "form.slug": function () {
            if (this.pageDocument) {
                this.generateUri();
                this.setBreadcrumb();
            }
        },
        form: {
            handler: function (newVal) {
                try {
                    let json = JSON.stringify(newVal);

                    if (this.initialForm && json !== this.initialForm) {
                        this.dirtyStore.isDirty = true;
                    }
                } catch (e) {
                    console.error(e);
                    console.log(newVal);
                }
            },
            deep: true,
        },
    },
    computed: {
        previewUrl: function () {
            return process.env.MIX_PREVIEW_URL;
        },
        hasErrors() {
            return !!Object.keys(this.errors).length;
        },
    },
};
